import React, { useEffect, useState } from "react";
import ImportScript from 'components/utils/ImportScript';
import Home from "pages/main/Home";
import "./loginForm.css"
import { warningErrorAction } from "actions/ErrorActions";  
import { useForm } from "service/UseForm"
import { useTranslation } from "react-i18next" 
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from 'react-toastify'; 
import { helpHttp } from "service/HelpHttp";
import { ENDPOINT, CLIENTE } from "constants/variables"; 
import FooterHome from "pages/main/FooterHome";
import coverVideo from "components/media/coverVideo.mp4";
import transporteIvan from "components/photos/transporte.jpg";
import DEMOEXTRANS from "components/photos/DEMOEXTRANS.jpg"; 
import JUANDAVID from "components/photos/JUANDAVID.png";  
import AFONSO from "components/photos/AFONSO.png";  
import JOSERAMON from "components/photos/JOSERAMON.png"; 
import GUTIERREZ from "components/photos/GUTIERREZ.png";
import VEGA from "components/photos/vega.png";
import JUANJOSE from "components/photos/JUANCARLOS.png";
import DIEGO from "components/photos/Diego.png"; 
import OJEDA from "components/photos/OJEDA.png"; 

import {
  loadFormatDIAction,
  resetFormatDIAction
} from "actions/FormatDIActions";

const isElectron = () => !!window.electron;
const ipcRenderer = isElectron() ? window.electron.ipcRenderer : null; 

const validationsForm = (form) => {
  let errors = {};
  if (!form.username) {
    errors.username = 'Text_UsuerRequired';
  }
  return errors;
};

const Login = () => { 
  const isVega = CLIENTE === 'VEGA';
  const { t } = useTranslation(['loginText']);
  const [loadVariables, setLoadVariables] = useState(false);
  const [credentialsLoaded, setCredentialsLoaded] = useState(false); 
  const token   = useSelector((s) => s.loginUser.token);
  const roles   = useSelector((s) => s.loginUser.roles);
  const enabled = useSelector((s) => s.loginUser.enabled);
  const typesdi_id = useSelector((s) => s.loginUser.defaulttypesdi.id); 

  const dispatch = useDispatch();

  const initialForm = {
    username: "",
    password: ""
  };

  const {
    form, 
    errors,
    handleChange,
    handleBlur,
    handleSubmit,
  } = useForm(initialForm, validationsForm);
  
  // Cargar una sola vez variables
  useEffect(() => {
    if (!loadVariables) setLoadVariables(true);
  }, [loadVariables]);
 
  // Cargar credenciales guardadas y auto-login UNA sola vez
  useEffect(() => {
    if (!isElectron() || credentialsLoaded) return;

    (async () => {
      try {
        const res = await ipcRenderer.invoke('get-credentials');
        if (res?.status === 'success' && res.password) {
          form.username = res.username;
          form.password = res.password;
          setTimeout(() => {
            handleSubmit({ preventDefault: () => {} });
          }, 0);
        }
        setCredentialsLoaded(true);
      } catch (e) {
        dispatch(warningErrorAction(t('Text_ValidCredentials')));
        setCredentialsLoaded(true);
      }  
    })();
  }, [credentialsLoaded, form,handleChange, handleSubmit, dispatch, t]);

  useEffect(() => {
    let isMounted = true;
      const fetchDataFormatDI = async () => {
        try {
          const getData = await helpHttp().get2(ENDPOINT,`typesdi/getformatdibytypeip/`,"",typesdi_id);
          if (getData.err || getData.message === "Load failed") {
            dispatch(resetFormatDIAction());
          } else if (isMounted) {
            dispatch(loadFormatDIAction(getData)); 
          }
        } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }  
      };
    
      if (enabled && typesdi_id!==undefined  && typesdi_id!==null  && typesdi_id!=="" ){
         fetchDataFormatDI();
      }  
    return () => { isMounted = false };
  }, [t,dispatch,loadVariables,token,enabled,typesdi_id]);
  
  useEffect(() => {
    if (!loadVariables){ 
      setLoadVariables(true);
    } 
  }, [dispatch,loadVariables]); 

  return (
    <>
      <ImportScript resourceUrl="/js/sb-admin-2.min.js" />
      <ToastContainer />
      {(enabled === true && roles?.[0]?.listmenus) ? (
        <Home/>
      ) : (
        <div className="login-page login-page-vega">
          {CLIENTE==='IVAN' && 
            <header className="header-banner">
              <img
                className="header-image"
                src={transporteIvan}
                alt="TRANSPORTES IVÁN OJEDA, S.L."
              />
            </header>
          }
          {CLIENTE==='AFONSO' && 
            <header className="headerafonso-banner">
              <img
                className="headerafonso-image"
                src={AFONSO}
                alt="TRANSPORTES Y EXCAVACIONES AFONSO E HIJOS, S.L."
              />
            </header>
          }
          {CLIENTE==='DEMOEXTRAN' && 
              <header className="headerdemo-banner">
                <img
                  className="headerdemo-image"
                  src={DEMOEXTRANS}
                  alt="TRANSPORTES DEMOEXTRANS CANARIAS, S.L."
                />
              </header>
            }
           {CLIENTE==='JUANDAVID' && 
              <header className="headerjuan-banner">
                <img
                  className="headerjuan-image"
                  src={JUANDAVID}
                  alt="TRANSPORTES JUAN DAVID"
                />
              </header>
            }
            {CLIENTE==='JUANJOSE' && 
              <header className="headervega-banner">
              <img
                className="headervega-image"
                  src={JUANJOSE}
                  alt="TRANSPORTES JUAN CARLOS SÁNCHEZ MARTÍN"
                />
              </header>
            }
            {CLIENTE==='GUTIERREZ' && 
              <header className="headergutierrez-banner">
                <img
                  className="headergutierrez-image"
                  src={GUTIERREZ}
                  alt="TRANSPORTES GUTIERREZ GRAN CANARIA"
                />
              </header>
            }
           {CLIENTE === 'ELBATAN' && (
              <div className="headerbatan-banner">
                <div className="headerbatan-content">
                  <div className="headerbatan-subtitle">
                    DESGUACE DE VEHÍCULOS INDUSTRIALES · VENTA DE REPUESTOS
                  </div>
                  <div className="headerbatan-title">
                    EL BATÁN
                  </div>
                </div>
              </div>
            )}
            {CLIENTE==='JOSERAMON' && 
              <header className="headerjose-banner">
                <img
                  className="headerjose-image"
                  src={JOSERAMON}
                  alt="José Ramón González Barbuzano."
                />
              </header>
            }
            {isVega && 
              <header className="headervega-banner">
              <img
                className="headervega-image"
                  src={VEGA}
                  alt="Transportes Grúa Mario Vega"
                />
              </header>
            }
            {CLIENTE==='DIEGO' && 
              <header className="headervega-banner">
                <img
                  className="headervega-image"
                  src={DIEGO}
                  alt="Diego Cristo Cárdenes Rodríguez."
                />
              </header>
            }
            {CLIENTE==='OJEDA' && 
              <header className="headervega-banner headerojeda-banner">
                <img
                className="headervega-image"
                  src={OJEDA}
                  alt="David Ojeda Cruz."
                />
              </header>
            }
            <div className="cover-container login-vega">
            <video className="video" src={coverVideo} autoPlay loop muted playsInline />
            <div className="row">
              <div className="col-lg-25">
                <div className="card border-0">
                    
                  <div className="card-body">
                    <div className="p-5">
                      <div className="text-center">
                        <h1 className="h2 text-gray-900 mb-4">{t('Text_Welcome')}</h1>
                      </div> 
                      {/* Importante: el onSubmit del form */}
                      <form className="user" onSubmit={handleSubmit}>
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control form-control-user"
                            aria-describedby="emailHelp"
                            name="username"
                            placeholder={t('Text_EnterUsername')}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={form.username}
                            required
                          />
                          {errors.username
                            ? <div className="small text-danger py-1 px-3">{t(errors.username)}</div>
                            : <div className="small text-danger py-1 px-3"><br/></div>}

                          {/* AHORA ES CONTROLADO */}
                          <input
                            type="password"
                            className="form-control form-control-user"
                            id="password"
                            name="password"
                            placeholder={t('Text_EnterPassword')}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={form.password}
                          />
                        </div>

                        <div className="text-center">
                          {/* No dispares handleSubmit aquí; deja que el form lo haga */}
                          <button className="buttonBlue" type="submit">
                            {t('Text_Login')}
                          </button>
                        </div>
                        <hr/>
                        <div className="login-brand-footer">
                          <a href="https://gestrescan.com" target="_blank" rel="noopener noreferrer" className="login-brand-link">
                            Gestrescan<span>, S.L.</span>
                          </a>
                        </div>
                      </form>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <FooterHome/>
        </div>
      )}
    </>
  );
};

export default Login;